//
import { mapActions, mapState } from 'vuex'
import { ModelDataTable } from '@/components/reusable_components/next'

//
import RepackingHistoricModel from '@/models/Warehouse/WhRepackingHistoric'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'purchase-order-list',
    components: {
        'crud-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                service: RepackingHistoricModel,
                filters,
                headers,
            }
        },
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
            setItemsTopBar: 'setItemsTopBar',
        }),

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'repacking-historic-create' })
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'repacking-historic-update',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Reenvasados')
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear reenvasado',
                tip: 'Crear nuevo reenvasado',
                can: 'CREATE_PRODUCT_REPACKING',
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT_REPACKING_HISTORIC'))
                ctx.$router.push('/')
        })
    },
}
